// extracted by mini-css-extract-plugin
export default {"lntFormItem":"styles_lnt-form-item__Gbrtk"};